<template>
  <b-row>
    <b-col v-if="logoUrl" class="d-flex justify-content-start">
      <router-link :to="'/' + $customerUuid + '/'">
        <img
          class="logo img-responsive"
          alt="Logo organizace"
          :src="logoUrl"
          @load="loaded"
        />
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "LogoOrganizace",
  data() {
    return {
      logoUrl: null,
    };
  },
  methods: {
    loaded() {
      if (this.logoUrl) URL.revokeObjectURL(this.logoUrl);
    },
  },
  mounted() {
    this.$backend.getLogo(response => {
      if ( this.$utils.hasResponseData(response) && response.data.size > 0) {
        this.logoUrl = URL.createObjectURL(new Blob([response.data]));
      }
    });
  },
};
</script>
